<template>
  <base-keyboard-component
    @addToInput="addToInputHandler"
    @removeLastChar="removeLastCharHander"
    :keyLayout="keyboardLayout"
  ></base-keyboard-component>
</template>

<script>
import BaseKeyboardComponent from "./BaseKeyboardComponent.vue";
import { mapGetters } from "vuex";

export default {
  name: "KeyboardComponent",
  components: { BaseKeyboardComponent },
  data() {
    return {
      layout: "letters",
      currentInput: "",
    };
  },
  mounted() {
    if (this.keyboard?.value === this.$i18n.t("id_check.not_found")) {
      this.$store.commit("SET_KEYBOARD_VALUE", "");
    }
  },
  computed: {
    ...mapGetters(["email"]),
    keyboardLayout() {
      return {
        letters: [
          [
            { label: "^" },
            { label: "1" },
            { label: "2" },
            { label: "3" },
            { label: "4" },
            { label: "5" },
            { label: "6" },
            { label: "7" },
            { label: "8" },
            { label: "9" },
            { label: "0" },
            { label: "backspace", action: "remove", classes: "four-col" },
          ],
          [
            { label: "tab", action: "tab", classes: "double-col"},
            { label: "Q" },
            { label: "W" },
            { label: "E" },
            { label: "R" },
            { label: "T" },
            { label: "Z" },
            { label: "U" },
            { label: "I" },
            { label: "O" },
            { label: "P" },
            { label: "Ü" },
          ],
          [
            { label: "caps", classes: "double-col", action: 'caps' },
            { label: "A" },
            { label: "S" },
            { label: "D" },
            { label: "F" },
            { label: "G" },
            { label: "H" },
            { label: "J" },
            { label: "K" },
            { label: "L" },
            { label: "Ö" },
            { label: "Ä" },
          ],
          [
            { label: "shift", action: "shift", classes: "four-col" },
            { label: "Y" },
            { label: "X" },
            { label: "C" },
            { label: "V" },
            { label: "B" },
            { label: "N" },
            { label: "M" },
            { label: "@" },
            { label: "." },
            { label: "123", action: "toggle"  },
          ],
        ],
        symbols: [
          [
            { label: "°" },
            { label: "!" },
            { label: '"' },
            { label: "§" },
            { label: "$" },
            { label: "%" },
            { label: "&" },
            { label: "/" },
            { label: "(" },
            { label: ")" },
            { label: "=" },
            { label: "backspace", action: "remove", classes: "four-col" },
          ],
          [
            { label: "@" },
            { label: "€" },
            { label: "+" },
            { label: "~" },
            { label: "*" },
            { label: "#" },
            { label: "'" },
            { label: "<" },
            { label: ">" },
            { label: "|" },
            { label: "µ" },
            { label: "ABC", action: "toggle" },
          ],
          [
            { label: ";" },
            { label: ":" },
            { label: "_" },
            { label: "-" },
          ],
        ],
      };
    },
  },
  methods: {
    toggleLayout() {
      this.layout = this.layout === "letters" ? "symbols" : "letters";
    },
    addToInputHandler(char) {
      let initialValue = this.email || "";

      initialValue += char;

      this.$store.commit("SET_EMAIL", initialValue);
    },
    removeLastCharHander() {
      let initialValue = this.email || "";

      initialValue = initialValue.slice(0, -1);

      this.$store.commit("SET_EMAIL", initialValue);
    },
  },
};
</script>